// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─────────────────────────────────────────────────────────────────────────────
   contentSectionEditPageBusiness.css
   Scoped prefix: scl--cms-content-edit-business-
   ───────────────────────────────────────────────────────────────────────────── */

/* ─── Root ──────────────────────────────────────────────────────────────────── */
.scl--cms-content-edit-business-root {
  width: 100%;
  max-width: 1920px;
  padding: 10px 130px 20px 130px;
  box-sizing: border-box;
  font-family: 'Inter', sans-serif;
}

/* ─── Skeleton ──────────────────────────────────────────────────────────────── */
.scl--cms-content-edit-business-skeleton-wrap {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 24px;
}

@keyframes scl--cms-content-edit-business-shimmer {
  0%   { background-position: 100% 50%; }
  100% { background-position:   0% 50%; }
}

.scl--cms-content-edit-business-skeleton {
  border-radius: 4px;
  background: linear-gradient(90deg, #F1F3F7 25%, #E8EBF0 50%, #F1F3F7 75%);
  background-size: 400% 100%;
  animation: scl--cms-content-edit-business-shimmer 1.4s ease infinite;
}
.scl--cms-content-edit-business-skeleton--title { height: 40px; width: 280px; }
.scl--cms-content-edit-business-skeleton--desc  { height: 20px; width: 460px; margin-bottom: 8px; }
.scl--cms-content-edit-business-skeleton--field { height: 44px; width: 100%; }

/* ─── Empty state ───────────────────────────────────────────────────────────── */
.scl--cms-content-edit-business-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  gap: 8px;
  text-align: center;
}
.scl--cms-content-edit-business-empty-title { font-size: 18px; font-weight: 600; color: #323539; margin: 0; }
.scl--cms-content-edit-business-empty-desc  { font-size: 14px; color: #8A8B8F; margin: 0 0 16px; }

/* ─── Page heading ──────────────────────────────────────────────────────────── */
.scl--cms-content-edit-business-page-title {
  margin: 0 0 6px;
  font-size: 36px;
  font-weight: 600;
  line-height: 40px;
  color: #323539;
}
.scl--cms-content-edit-business-page-desc {
  margin: 0 0 28px;
  font-size: 16px;
  line-height: 24px;
  color: #8A8B8F;
  letter-spacing: -0.01em;
}

/* ─── Meta grid ─────────────────────────────────────────────────────────────── */
.scl--cms-content-edit-business-meta-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 24px;
  margin-bottom: 32px;
}
.scl--cms-content-edit-business-meta-grid > *:nth-child(5) { grid-column: 1; }

/* ─── Section heading row — heading left, toggle right ──────────────────────── */
.scl--cms-content-edit-business-section-heading-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.scl--cms-content-edit-business-section-heading {
  font-size: 16px;
  font-weight: 600;
  color: #323539;
  margin: 0;
}

/* ─── Divider ───────────────────────────────────────────────────────────────── */
.scl--cms-content-edit-business-divider {
  height: 1px;
  background: #E1E4ED;
  margin-bottom: 20px;
}

/* ─── Label row ─────────────────────────────────────────────────────────────── */
.scl--cms-content-edit-business-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
  margin-bottom: 8px;
}
.scl--cms-content-edit-business-label        { font-size: 14px; color: #323539; font-weight: 400; }
.scl--cms-content-edit-business-label--bold  { font-weight: 600; }
.scl--cms-content-edit-business-required     { color: #FF4D4F; }

/* ─── SplitRow ──────────────────────────────────────────────────────────────── */
.scl--cms-content-edit-business-split-row {
  box-sizing: border-box;
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 60px;
  background: #FDFDFD;
  border: 1px dashed rgba(208, 213, 221, 0.3);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 4px;
}

.scl--cms-content-edit-business-split-row--multiline {
  min-height: 110px;
  align-items: flex-start;
}

/* Green left accent bar */
.scl--cms-content-edit-business-split-accent {
  width: 4px;
  flex-shrink: 0;
  background: #84A578;
  border-radius: 0 0 2px 2px;
  align-self: stretch;
}

/* Row body */
.scl--cms-content-edit-business-split-body {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px 10px 16px;
  gap: 12px;
  min-height: 60px;
}

.scl--cms-content-edit-business-split-row--multiline
.scl--cms-content-edit-business-split-body {
  align-items: flex-start;
  padding-top: 14px;
  padding-bottom: 14px;
  min-height: 110px;
}

/* Current value — left */
.scl--cms-content-edit-business-split-current {
  flex: 1;
  font-size: 16px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.8);
  word-break: break-word;
}

/* Input slot — right */
.scl--cms-content-edit-business-split-slot {
  flex-shrink: 0;
  width: 240px;
}

/* Textarea slot */
.scl--cms-content-edit-business-split-slot--textarea {
  width: 351px;
}
.scl--cms-content-edit-business-split-slot--textarea textarea {
  max-height: 110px;
  overflow-y: auto;
  resize: none;
  box-sizing: border-box;
}

/* ─── Footer actions ────────────────────────────────────────────────────────── */
.scl--cms-content-edit-business-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 24px;
}`, "",{"version":3,"sources":["webpack://./src/page-controller-mod/page-serv/content/edit-content/business-contact-page/css/contentSectionEditPageBusiness.css"],"names":[],"mappings":"AAAA;;;kFAGkF;;AAElF,kFAAkF;AAClF;EACE,WAAW;EACX,iBAAiB;EACjB,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,OAAO,6BAA6B,EAAE;EACtC,OAAO,6BAA6B,EAAE;AACxC;;AAEA;EACE,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,oEAAoE;AACtE;AACA,kDAAkD,YAAY,EAAE,YAAY,EAAE;AAC9E,kDAAkD,YAAY,EAAE,YAAY,EAAE,kBAAkB,EAAE;AAClG,kDAAkD,YAAY,EAAE,WAAW,EAAE;;AAE7E,kFAAkF;AAClF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,QAAQ;EACR,kBAAkB;AACpB;AACA,8CAA8C,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,SAAS,EAAE;AAC5G,8CAA8C,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;;AAEjG,kFAAkF;AAClF;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;AACrB;AACA,6DAA6D,cAAc,EAAE;;AAE7E,kFAAkF;AAClF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,kFAAkF;AAClF;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;AACA,+CAA+C,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAClG,+CAA+C,gBAAgB,EAAE;AACjE,+CAA+C,cAAc,EAAE;;AAE/D,kFAAkF;AAClF;EACE,sBAAsB;EACtB,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,0BAA0B;AAC1B;EACE,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,OAAO;EACP,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;AACnB","sourcesContent":["/* ─────────────────────────────────────────────────────────────────────────────\n   contentSectionEditPageBusiness.css\n   Scoped prefix: scl--cms-content-edit-business-\n   ───────────────────────────────────────────────────────────────────────────── */\n\n/* ─── Root ──────────────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-business-root {\n  width: 100%;\n  max-width: 1920px;\n  padding: 10px 130px 20px 130px;\n  box-sizing: border-box;\n  font-family: 'Inter', sans-serif;\n}\n\n/* ─── Skeleton ──────────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-business-skeleton-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding-top: 24px;\n}\n\n@keyframes scl--cms-content-edit-business-shimmer {\n  0%   { background-position: 100% 50%; }\n  100% { background-position:   0% 50%; }\n}\n\n.scl--cms-content-edit-business-skeleton {\n  border-radius: 4px;\n  background: linear-gradient(90deg, #F1F3F7 25%, #E8EBF0 50%, #F1F3F7 75%);\n  background-size: 400% 100%;\n  animation: scl--cms-content-edit-business-shimmer 1.4s ease infinite;\n}\n.scl--cms-content-edit-business-skeleton--title { height: 40px; width: 280px; }\n.scl--cms-content-edit-business-skeleton--desc  { height: 20px; width: 460px; margin-bottom: 8px; }\n.scl--cms-content-edit-business-skeleton--field { height: 44px; width: 100%; }\n\n/* ─── Empty state ───────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-business-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 50vh;\n  gap: 8px;\n  text-align: center;\n}\n.scl--cms-content-edit-business-empty-title { font-size: 18px; font-weight: 600; color: #323539; margin: 0; }\n.scl--cms-content-edit-business-empty-desc  { font-size: 14px; color: #8A8B8F; margin: 0 0 16px; }\n\n/* ─── Page heading ──────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-business-page-title {\n  margin: 0 0 6px;\n  font-size: 36px;\n  font-weight: 600;\n  line-height: 40px;\n  color: #323539;\n}\n.scl--cms-content-edit-business-page-desc {\n  margin: 0 0 28px;\n  font-size: 16px;\n  line-height: 24px;\n  color: #8A8B8F;\n  letter-spacing: -0.01em;\n}\n\n/* ─── Meta grid ─────────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-business-meta-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px 24px;\n  margin-bottom: 32px;\n}\n.scl--cms-content-edit-business-meta-grid > *:nth-child(5) { grid-column: 1; }\n\n/* ─── Section heading row — heading left, toggle right ──────────────────────── */\n.scl--cms-content-edit-business-section-heading-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.scl--cms-content-edit-business-section-heading {\n  font-size: 16px;\n  font-weight: 600;\n  color: #323539;\n  margin: 0;\n}\n\n/* ─── Divider ───────────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-business-divider {\n  height: 1px;\n  background: #E1E4ED;\n  margin-bottom: 20px;\n}\n\n/* ─── Label row ─────────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-business-label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 16px;\n  margin-bottom: 8px;\n}\n.scl--cms-content-edit-business-label        { font-size: 14px; color: #323539; font-weight: 400; }\n.scl--cms-content-edit-business-label--bold  { font-weight: 600; }\n.scl--cms-content-edit-business-required     { color: #FF4D4F; }\n\n/* ─── SplitRow ──────────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-business-split-row {\n  box-sizing: border-box;\n  display: flex;\n  align-items: stretch;\n  width: 100%;\n  min-height: 60px;\n  background: #FDFDFD;\n  border: 1px dashed rgba(208, 213, 221, 0.3);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 4px;\n}\n\n.scl--cms-content-edit-business-split-row--multiline {\n  min-height: 110px;\n  align-items: flex-start;\n}\n\n/* Green left accent bar */\n.scl--cms-content-edit-business-split-accent {\n  width: 4px;\n  flex-shrink: 0;\n  background: #84A578;\n  border-radius: 0 0 2px 2px;\n  align-self: stretch;\n}\n\n/* Row body */\n.scl--cms-content-edit-business-split-body {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 12px 10px 16px;\n  gap: 12px;\n  min-height: 60px;\n}\n\n.scl--cms-content-edit-business-split-row--multiline\n.scl--cms-content-edit-business-split-body {\n  align-items: flex-start;\n  padding-top: 14px;\n  padding-bottom: 14px;\n  min-height: 110px;\n}\n\n/* Current value — left */\n.scl--cms-content-edit-business-split-current {\n  flex: 1;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 0, 0, 0.8);\n  word-break: break-word;\n}\n\n/* Input slot — right */\n.scl--cms-content-edit-business-split-slot {\n  flex-shrink: 0;\n  width: 240px;\n}\n\n/* Textarea slot */\n.scl--cms-content-edit-business-split-slot--textarea {\n  width: 351px;\n}\n.scl--cms-content-edit-business-split-slot--textarea textarea {\n  max-height: 110px;\n  overflow-y: auto;\n  resize: none;\n  box-sizing: border-box;\n}\n\n/* ─── Footer actions ────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-business-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding-top: 24px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
